Apt.fn.make('support', {
	/**
	 * Initialize module
	 */
	init() {
		const $search = $$('supportSearch');

		$search.on('submit', () => {
			$.history.go('/support/filter/keywords=' + encodeURIComponent(
				$.first('input', $search).value
			));
		}, {
			cancel: true,
			namespace: 'support'
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('support');
	}
});